import { UserSignInStatus } from '../../features/user/types'
import WebAppSignedIn from './WebAppSignedIn'
import WebAppSignedOut from './WebAppSignedOut'
import useSignInState from './hooks/useSignInState'

const NewWebApp = () => (useSignInState() === UserSignInStatus.SIGNED_IN ? <WebAppSignedIn /> : <WebAppSignedOut />)

export default NewWebApp
